﻿import React from 'react';
import styled from 'styled-components';

import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

const BackButton = props => {
    return <Button {...props}>{props.children}</Button>;
}

const Button = styled.button`
    display: inline-block; 
    margin-right: 20px;
    font-family: ${definitions.fonts.heading};
    font-size: 18px;
    font-weight: normal;

    color: ${definitions.colors.almostBlack};

    background-color: transparent; 

    &:before {
        color: white;
        padding-right: 20px; 
        font-size: 14px;

        color: ${definitions.colors.almostBlack};

        ${iconCode.arrowLeft()}
        transition: transform 300ms ease-out; 
    }

`;

export default BackButton;

